import { render } from "./ProductsRange.vue?vue&type=template&id=bd6068be&scoped=true"
import script from "./ProductsRange.vue?vue&type=script&lang=js"
export * from "./ProductsRange.vue?vue&type=script&lang=js"

import "./ProductsRange.vue?vue&type=style&index=0&id=bd6068be&scoped=true&lang=scss"

import exportComponent from "/Users/skynet/Documents/Sites Safe OK MAIS PEUT ETRE PAS A JOUR/Safe_Sites_Modifs/SAFE_ORTHO/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd6068be"]])

export default __exports__